export default function BusinessSummary() {
  const businesses = [
    {
      icon: 'ri-coin-line',
      title: 'インドネシア・ステーブルコイン事業',
      subtitle: 'インドネシアの決済インフラを、もっと安全・便利に',
      description: 'ブロックチェーン技術を活用し、安定した価値を持つステーブルコインをインドネシアで発行・運用するプロジェクトを推進しています。送金・決済コストの削減、金融包摂の向上を通じて、現地の生活者・事業者双方の利便性向上を目指します。',
      image: 'https://public.readdy.ai/ai/img_res/da52c9d32a67e99cb3b748ae69ee53ef.jpg'
    },
    {
      icon: 'ri-cup-line',
      title: '輸入事業（コーヒーなど）',
      subtitle: '生産者と日本の食卓をダイレクトにつなぐ輸入ビジネス',
      description: 'インドネシアをはじめとするアジア各地から、ストーリーのあるコーヒーや食品を輸入。生産者とのフェアな取引と、豊かな味わいを日本の消費者へ届けることを大切にしています。',
      image: 'https://readdy.ai/api/search-image?query=Premium%20specialty%20coffee%20beans%20from%20Indonesia%2C%20coffee%20plantation%20in%20Asian%20mountains%2C%20fresh%20roasted%20coffee%20with%20simple%20white%20background%2C%20elegant%20product%20photography%20style%20with%20natural%20lighting%2C%20blue%20accent%20elements&width=600&height=400&seq=business-002&orientation=landscape'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'AI健康・生活アプリ「クラティブ」',
      subtitle: '暮らしをアクティブにする、地域密着型総合アプリ',
      description: '「クラティブ」は、医療・介護・生活支援・エンタメまで、地域での暮らしに必要な情報とサービスを一つにまとめた生活ポータルアプリです。対話型AIによる簡易健康問診、服薬支援、なんでも相談、施設検索・予約など、多機能をスマートフォン一つで利用できます。',
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20AI%20application%20interface%20on%20smartphone%2C%20elderly%20person%20using%20health%20app%20with%20friendly%20AI%20assistant%2C%20modern%20Japanese%20home%20setting%2C%20clean%20white%20and%20blue%20design%2C%20warm%20and%20accessible%20technology%20atmosphere&width=600&height=400&seq=business-003&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: '防水コンクリートなど新技術',
      subtitle: 'インフラの長寿命化とメンテナンスコスト削減へ',
      description: '建設・土木分野では、防水性能や耐久性を高める新素材・新工法の導入を進めています。建物・インフラの寿命を伸ばすことで、暮らしの安全性向上と、企業・自治体のコスト削減に貢献します。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20concrete%20infrastructure%20construction%20site%2C%20waterproof%20concrete%20technology%20application%2C%20durable%20building%20materials%20with%20blue%20protective%20coating%2C%20professional%20construction%20photography%20with%20clean%20white%20background&width=600&height=400&seq=business-004&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 md:py-32 px-6 md:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p className="text-sm tracking-widest uppercase mb-4 text-blue-600 font-medium">
            Our Business
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
            4つの事業領域
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto leading-relaxed">
            テクノロジーを活用し、アジアと日本の暮らしを豊かにする4つの事業を展開しています
          </p>
        </div>

        {/* Business Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {businesses.map((business, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={business.image}
                  alt={business.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-xl shadow-lg">
                  <i className={`${business.icon} text-2xl text-blue-600`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-blue-900 mb-2 leading-tight">
                  {business.title}
                </h3>
                <p className="text-sm font-medium text-blue-600 mb-4 leading-snug">
                  {business.subtitle}
                </p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {business.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
